import { createRouter, createWebHashHistory } from "vue-router";
import store from "../store";

const routes = [
  {
    path: "/",
    name: "Home",
    meta: {
      auth: true,
      title: "میزکار",
    },
    component: () => import("../views/register/Home.vue"),
  },
  {
    path: "/admin/",
    name: "AdminHome",
    meta: {
      auth: true,
      title: 'مدیریت'+process.env.VUE_APP_TITLE,
    },
    component: () => import("../views/AdminHome.vue"),
  },
  {
    path: "/login/:pathAfterLogin?",
    name: "Login",
    meta: {
      auth: false,
      title: "ورود به حساب",
    },
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/register",
    name: "Register",
    meta: {
      auth: false,
      title: "ثبت نام",
    },
    component: () => import("../views/Register.vue"),
  },
  {
    path: "/register-login",
    name: "RegisterLogin",
    meta: {
      auth: false,
      title: "ورود / عضویت",
    },
    component: () => import("../views/RegisterLogin.vue"),
  },
  {
    path: "/register-login-free-conference/:product_detail_videos_id",
    name: "RegisterLoginFreeConference",
    meta: {
      auth: false,
      title: "ورود به همایش",
    },
    component: () => import("../views/RegisterLoginFreeConference.vue"),
  },
  {
    path: "/forgetpassword",
    name: "Forgetpassword",
    meta: {
      auth: false,
      title: "فراموشی رمز عبور",
    },
    component: () => import("../views/Forgetpassword.vue"),
  },
  {
    path: "/admin/adduser",
    name: "AddUser",
    meta: {
      auth: true,
      title: "افزودن کاربر",
    },
    component: () => import("../views/AddUser.vue"),
  },
  {
    path: "/admin/listusers/:page?",
    name: "ListUsers",
    meta: {
      auth: true,
      title: "فهرست کاربر",
    },
    component: () => import("../views/ListUsers.vue"),
  },
  {
    path: "/admin/user/edit/:userId",
    name: "UserEdit",
    meta: {
      auth: true,
      title: "ویرایش کاربر",
    },
    component: () => import("../views/AddUser.vue"),
  },
  {
    path: "/admin/listproducts/:page?",
    name: "ListProducts",
    meta: {
      auth: true,
      title: "فهرست محصولات",
    },
    component: () => import("../views/ListProducts.vue"),
  },
  {
    path: "/admin/addproduct",
    name: "AddProducts",
    meta: {
      auth: true,
      title: "محصول جدید",
    },
    component: () => import("../views/AddProducts.vue"),
  },
  {
    path: "/admin/product/edit/:productId",
    name: "EditProduct",
    meta: {
      auth: true,
      title: "ویرایش محصول",
    },
    component: () => import("../views/AddProducts.vue"),
  },
  {
    path: "/admin/listcategoryones/:page?",
    name: "ListCategoryones",
    meta: {
      auth: true,
      title: "فهرست دسته بندی سطح یک",
    },
    component: () => import("../views/ListCategoryones.vue"),
  },
  {
    path: "/admin/categoryone/add",
    name: "AddCategoryone",
    meta: {
      auth: true,
      title: "افزودن دسته سطح یک",
    },
    component: () => import("../views/AddCategoryone.vue"),
  },
  {
    path: "/admin/categoryone/edit/:categoryoneId",
    name: "EditCategoryone",
    meta: {
      auth: true,
      title: "ویرایش دسته سطح یک",
    },
    component: () => import("../views/AddCategoryone.vue"),
  },
  {
    path: "/admin/listcategorytwos/:page?",
    name: "ListCategorytwos",
    meta: {
      auth: true,
      title: "فهرست دسته بندی سطح دو",
    },
    component: () => import("../views/ListCategorytwos.vue"),
  },
  {
    path: "/admin/categorytwo/add",
    name: "AddCategorytwo",
    meta: {
      auth: true,
      title: "افزودن دسته سطح دو",
    },
    component: () => import("../views/AddCategorytwo.vue"),
  },
  {
    path: "/admin/categorytwo/edit/:categorytwoId",
    name: "EditCategorytwo",
    meta: {
      auth: true,
      title: "ویرایش دسته سطح دو",
    },
    component: () => import("../views/AddCategorytwo.vue"),
  },
  {
    path: "/admin/listcategorythrees/:page?",
    name: "ListCategorythrees",
    meta: {
      auth: true,
      title: "فهرست دسته بندی سطح سه",
    },
    component: () => import("../views/ListCategorythrees.vue"),
  },
  {
    path: "/admin/categorythree/add",
    name: "AddCategorythree",
    meta: {
      auth: true,
      title: "افزودن دسته سطح سه",
    },
    component: () => import("../views/AddCategorythree.vue"),
  },
  {
    path: "/admin/categorythree/edit/:categorythreeId",
    name: "EditCategorythree",
    meta: {
      auth: true,
      title: "ویرایش دسته سطح سه",
    },
    component: () => import("../views/AddCategorythree.vue"),
  },
  {
    path: "/admin/listcoupons/:page?",
    name: "ListCoupons",
    meta: {
      auth: true,
      title: "فهرست کدهای تخفیف",
    },
    component: () => import("../views/ListCoupons.vue"),
  },
  {
    path: "/admin/coupons/add",
    name: "AddCoupons",
    meta: {
      auth: true,
      title: "افزودن کد تخفیف",
    },
    component: () => import("../views/AddCoupons.vue"),
  },
  {
    path: "/admin/coupons/edit/:couponId",
    name: "EditCoupon",
    meta: {
      auth: true,
      title: "ویرایش کدهای تخفیف",
    },
    component: () => import("../views/AddCoupons.vue"),
  },
  {
    path: "/admin/reports/:productId?",
    name: "SaleReports",
    meta: {
      auth: true,
      title: "گزارش فروش",
    },
    component: () => import("../views/SaleReports.vue"),
  },
  {
    path: "/admin/product-report",
    name: "ProductReport",
    meta: {
      auth: true,
      title: "گزارش کلی فروش",
    },
    component: () => import("../views/ProductReport.vue"),
  },
  {
    path: "/admin/comments/:page?",
    name: "ListComments",
    meta: {
      auth: true,
      title: "نظرات",
    },
    component: () => import("../views/ListComments"),
  },
  {
    path: "/admin/sessions/:productId?/:page?",
    name: "Sessions",
    meta: {
      auth: true,
      title: "جلسات",
    },
    component: () => import("../views/Sessions.vue"),
  },
  {
    path: "/admin/packages/:productId?",
    name: "Packages",
    meta: {
      auth: true,
      title: "محصولات زیر مجموعه پکیج",
    },
    component: () => import("../views/Packages.vue"),
  },
  {
    path: "/admin/addorder/:userId?/:userFullName?",
    name: "AddOrder",
    meta: {
      auth: true,
      title: "ایجاد فاکتور جدید",
    },
    component: () => import("../views/AddOrder/index.vue"),
  },
  {
    path: "/admin/videosession/:productId/:videoSessionId",
    name: "AdminVideoSession",
    meta: {
      auth: true,
      title: "جزئیات جلسه",
    },
    component: () => import("../views/VideoSession.vue"),
  },
  {
    path: "/admin/videosessionplay/:productDetailViedosId/:videoSessionName",
    name: "AdminVideoSessionPlay",
    meta: {
      auth: true,
      title: "مشاهده ویدیو",
    },
    component: () => import("../views/VideoSessionPlay.vue"),
  },
  {
    path: "/profile",
    name: "Profile",
    meta: {
      auth: true,
      title: "پروفایل",
    },
    component: () => import("../views/register/Profile.vue"),
  },
  {
    path: "/shop",
    name: "Shop",
    meta: {
      auth: true,
      title: "فروشگاه",
    },
    component: () => import("../views/register/Shop.vue"),
  },
  {
    path: "/lives",
    name: "Lives",
    meta: {
      auth: true,
      title: "پخش زنده",
    },
    component: () => import("../views/register/Lives.vue"),
  },
  {
    path: "/complete-courses",
    name: "CompleteCourses",
    meta: {
      auth: true,
      title: "دوره‌های کامل",
    },
    component: () => import("../views/register/CompleteCourses.vue"),
  },
  {
    path: "/single-sessions",
    name: "SingleSessions",
    meta: {
      auth: true,
      title: "تک جلسات من",
    },
    component: () => import("../views/register/SingleSessions.vue"),
  },
  {
    path: "/orders",
    name: "Orders",
    meta: {
      auth: true,
      title: "امور مالی",
    },
    component: () => import("../views/register/Orders.vue"),
  },
  {
    path: "/orderdetails/:orderId",
    name: "OrderDetails",
    meta: {
      auth: true,
      title: "جزئیات فاکتور",
    },
    component: () => import("../views/register/OrderDetails.vue"),
  },
  {
    path: "/free",
    name: "FreeSessions",
    meta: {
      auth: true,
      title: "جلسات رایگان",
    },
    component: () => import("../views/register/FreeSessions.vue"),
  },
  {
    path: "/freequiz",
    name: "FreeQuiz",
    meta: {
      auth: true,
      title: "آزمون‌های رایگان",
    },
    component: () => import("../views/register/FreeQuiz.vue"),
  },
  {
    path: "/category-one/:categoryOneId",
    name: "CategoryOne",
    meta: {
      auth: true,
      title: "محصولات",
    },
    component: () => import("../views/register/CategoryOne.vue"),
  },
  {
    path: "/products/:productId/:buyed_before?",
    name: "Products",
    meta: {
      auth: true,
      title: "محصول",
    },
    component: () => import("../views/register/Products/Products.vue"),
  },
  {
    path: "/cart",
    name: "Cart",
    meta: {
      auth: true,
      title: "سبد خرید",
    },
    component: () => import("../views/register/Cart.vue"),
  },
  {
    path: "/videosession/:productId/:videoSessionId",
    name: "VideoSession",
    meta: {
      auth: true,
      title: "جزئیات جلسه",
    },
    component: () => import("../views/register/VideoSession.vue"),
  },
  {
    path: "/purchase/:orderId/:status",
    name: "Purchase",
    meta: {
      auth: false,
      title: "بازگشت از بانک",
    },
    component: () => import("../views/register/Purchase.vue"),
  },
  {
    path: "/videosessionplay/:productDetailViedosId/:videoSessionName",
    name: "VideoSessionPlay",
    meta: {
      auth: true,
      title: "مشاهده ویدیو",
    },
    component: () => import("../views/register/VideoSessionPlay.vue"),
  },
  {
    path: "/admin/presence-report/:product_detail_videos_id?",
    name: "PresenceReport",
    meta: {
      auth: true,
      title: "گزارش حضور و غیاب",
    },
    component: () => import("../views/PresenceReport.vue"),
  },
  {
    path: "/admin/exam-presence-report/:page?",
    name: "ExampPresenceReport",
    meta: {
      auth: true,
      title: "گزارش حضور و غیاب آزمون",
    },
    component: () => import("../views/ExamPresenceReport.vue"),
  },
  {
    path: "/admin/chairs/:productId",
    name: "Chairs",
    meta: {
      auth: true,
      title: "مدیریت صندلی ها",
    },
    component: () => import("../views/Chairs/index.vue"),
  },
  {
    path: "/my-team",
    name: "Team",
    meta: {
      auth: true,
      title: "تیم من",
    },
    component: () => import("../views/register/Team/index.vue"),
  },
  {
    path: "/admin/conference-report",
    name: "ConferenceReport",
    meta: {
      auth: true,
      title: "گزارش همایش ها ",
    },
    component: () => import("../views/ConferenceReport/index.vue"),
  },
  {
    path: "/admin/teams/:page?",
    name: "AdminTeams",
    meta: {
      auth: true,
      title: "مدیریت تیم‌ها",
    },
    component: () => import("../views/Team/index.vue"),
  },
  {
    path: "/admin/manage-free",
    name: "Manage-free-sessions",
    meta: {
      auth: true,
      title: "مدیریت جلسات رایگان",
    },
    component: () => import("../views/ListFreeSessions.vue"),
  },
  {
    path: "/admin/quiz/:productId",
    name: "Quiz",
    meta: {
      auth: true,
      title: "مدیریت آزمون‌ها",
    },
    
    component: () => import("../views/Quiz/index.vue"),
  },
  {
    path: "/my-quiz",
    name: "CompleteQuizes",
    meta: {
      auth: true,
      title: "آزمون‌های من",
    },
    component: () => import("../views/register/CompleteQuizes.vue"),
  },
  {
    path: "/admin/schools/:page?",
    name: "AdminSchools",
    meta: {
      auth: true,
      title: "مدیریت مدارس",
    },
    component: () => import("../views/Schools/index.vue"),
  },
  {
    path: "/admin/schools/add",
    name: "AddSchool",
    meta: {
      auth: true,
      title: "افزودن مدرسه",
    },
    component: () => import("../views/Schools/AddSchool.vue"),
  },
  {
    path: "/admin/schools/edit/:schoolId",
    name: "SchoolEdit",
    meta: {
      auth: true,
      title: "ویرایش مدرسه",
    },
    component: () => import("../views/Schools/AddSchool.vue"),
  },
  {
    path: "/admin/banners",
    name: "Banners",
    meta: {
      auth: true,
      title: "مدیریت بنرها",
    },
    component: () => import("../views/Banners/index.vue"),
  },
  {
    path: "/admin/banners/create",
    name: "AddBanner",
    meta: {
      auth: true,
      title: "افزودن بنر",
    },
    component: () => import("../views/Banners/AddBanner.vue"),
  },
  {
    path: "/admin/banners/edit/:bannerId",
    name: "EditBanner",
    meta: {
      auth: true,
      title: "ویرایش بنر",
    },
    component: () => import("../views/Banners/AddBanner.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    component: import("../views/NotFound.vue"),
    name: "404",
  },
];

const router = createRouter({
  //history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.auth)) {
    if (!store.state.token) {
      next({
        name: "RegisterLogin",
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
